export const CREATE_SECRETARY = {
    REQUEST:"CREATE_SECRETARY_REQUEST",
    SUCCESS:"CREATE_SECRETARY_SUCCESS",
    FAIL:"CREATE_SECRETARY_FAIL",
}

export const GET_SECRETARY = {
    REQUEST:"GET_SECRETARY_REQUEST",
    SUCCESS:"GET_SECRETARY_SUCCESS",
    FAIL:"GET_SECRETARY_FAIL",
}

export const GET_SECRETARIES = {
    REQUEST:"GET_SECRETARIES_REQUEST",
    SUCCESS:"GET_SECRETARIES_SUCCESS",
    FAIL:"GET_SECRETARIES_FAIL",
}

export const UPDATE_SECRETARY = {
    REQUEST:"UPDATE_SECRETARY_REQUEST",
    SUCCESS:"UPDATE_SECRETARY_SUCCESS",
    FAIL:"UPDATE_SECRETARY_FAIL",
}

export const DELETE_SECRETARY = {
    REQUEST:"DELETE_SECRETARY_REQUEST",
    SUCCESS:"DELETE_SECRETARY_SUCCESS",
    FAIL:"DELETE_SECRETARY_FAIL",
}